module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_7016.cda0c748.png";